import { defineMessages } from 'react-intl';

export default defineMessages({
    affiliationDetials: {
        id: 'ml.policychange.affiliation.Affiliation Details',
        defaultMessage: 'Affiliation Details'
    },
    searchAlert: {
        id: 'ml.policychange.affiliation.searchAlert',
        defaultMessage: 'There may be multiple options for your listed Employer/Affiliation. Please click SEARCH and choose the appropriate match for your situation.'
    },
    baseWizardMessageNonRenters: {
        id: 'ml.policychange.affiliation.wizardMessagePa',
        defaultMessage: 'We’ll find your {boldText} next'
    },
    driversAndVehicles: {
        id: 'ml.policychange.affiliation.driversAndVehicles',
        defaultMessage: 'drivers and vehicles'
    },
    affiliationHeader: {
        id: 'ml.policychange.affiliation.affiliationHeader',
        defaultMessage: 'Tell us about your employer or affiliation'
    },
    policyInfo: {
        id: 'ml.policychange.affiliation.policyInfo',
        defaultMessage: 'policy info'
    },
    discounts: {
        id: 'ml.policychange.affiliation.discounts',
        defaultMessage: 'discounts'
    },
    groupDiscounts: {
        id: 'ml.policychange.affiliation.groupDiscounts',
        defaultMessage: 'Group Discounts'
    },
    gpaSectionHeader: {
        id: 'ml.policychange.affiliation.gpaSectionHeader',
        defaultMessage: 'Employer or Affiliation'
    },
    nextBaseDescription: {
        id: 'ml.policychange.affiliation.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.affiliation.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    makeChanges: {
        id: 'ml.policychange.affiliation.makeChanges',
        defaultMessage: 'Make Changes'
    },
    updatedEmployerAffiliation: {
        id: 'ml.policychange.affiliation.Updated Employer and/or Affiliation',
        defaultMessage: 'Updated Employer and/or Affiliation'
    },
    payrollDeductWarning: {
        id: 'ml.policychange.affiliation.payrollDeductWarning',
        defaultMessage: '<b>Policy is already on payroll deduction.</b><br></br>To change employers, remove policy from payroll deduct on the Billing Details page.'
    }
});
